<div class="tml-tpl-label">
    <label><span *ngIf="isEmploymentCompany">Company: </span>{{content}}</label>
</div>